import type { RumPublicApi } from '@datadog/browser-rum-core';

declare global {
  interface Window {
    DD_RUM?: RumPublicApi;
    RUNTIME_ENV?: string;
  }
}

interface addTiming {
  name: string;
  time?: number;
}

interface PhoenixLiveViewJSEvent extends Event {
  detail: addTiming;
}

export const trackTiming = (name: string, time?: number): void => {
  if (window.RUNTIME_ENV !== 'prod') {
    // eslint-disable-next-line no-console
    console.log('tracking timing for', name, time);
  }
  window.DD_RUM?.addTiming?.(name, time);
};

window.addEventListener('track_timing', (e: PhoenixLiveViewJSEvent) => {
  trackTiming(e.detail.name, e.detail.time);
});
